"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import i18n from "@/lang";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import jsQR from "jsqr";
import URLParse from "url-parse";
import totpmodel from "@/utils/totp";
export class AddTOTPByManualFrom extends UiFormController {
  constructor() {
    super(...arguments);
    this.secret = "";
    this.account = "";
    this.name = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_totp_dialog.add_totp_form.add_secret_tip"),
      trigger: "blur"
    }
  ])
], AddTOTPByManualFrom.prototype, "secret", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t(
        "add_totp_dialog.add_totp_form.add_account_tip"
      ),
      trigger: "blur"
    }
  ])
], AddTOTPByManualFrom.prototype, "account", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_totp_dialog.add_totp_form.add_name_tip"),
      trigger: "blur"
    }
  ])
], AddTOTPByManualFrom.prototype, "name", 2);
let AddTOTPDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.formcontroller = new AddTOTPByManualFrom();
    this.activeName = "qrcode";
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    return __async(this, null, function* () {
    });
  }
  cancelAdd() {
    this.close();
    this.formcontroller.clear();
    this.formcontroller.account = "";
    this.formcontroller.name = "";
    this.formcontroller.secret = "";
  }
  addTOTP() {
    return __async(this, null, function* () {
      try {
        if (this.formcontroller.secret && this.formcontroller.secret.length < 16) {
          this.$message.error(this.$t("add_totp_dialog.wrong_secret_tip"));
          return;
        }
        totpmodel.getToken(this.formcontroller.secret, {});
        this.$emit("uploadSuccess", { "username": this.formcontroller.account, "secret": this.formcontroller.secret, "name": this.formcontroller.name, "bindShopNum": 1 });
        this.$message.success(this.$t("add_totp_dialog.add_totp_success"));
        this.cancelAdd();
      } catch (error) {
        this.$message.error(this.$t("add_totp_dialog.wrong_secret_tip"));
      }
    });
  }
  beforeAvatarUpload(file) {
    return __async(this, null, function* () {
      const isPic = file.type === "image/jpeg" || file.type === "image/png";
      if (!isPic) {
        this.$message.error(
          this.$t("change_paypal_account_dialog.paypal_pay_type")
        );
        return isPic;
      }
      return isPic;
    });
  }
  handleFile(request) {
    return __async(this, null, function* () {
      try {
        let data = yield this.getImageSize(request.file);
        if (data.width) {
          const imageData = yield this.base64ToImageData(
            data.imageData,
            data.width,
            data.height
          );
          const qrdata = jsQR(imageData.data, data.width, data.height);
          if (qrdata) {
            if ((qrdata == null ? void 0 : qrdata.data.indexOf("otpauth")) !== -1 && (qrdata == null ? void 0 : qrdata.data.indexOf("totp")) !== -1) {
              let otpurl = qrdata.data;
              let realurl = decodeURIComponent(otpurl);
              const _url = new URLParse(realurl);
              let username = _url.pathname.split(":")[1];
              if (username === "" || username === null) {
                username = this.getQueryVariable(_url.query, "username");
                if (username === false) {
                  username = this.getQueryVariable(_url.query, "issuer");
                }
                if (username === false) {
                  username = this.getQueryVariable(_url.query, "user");
                }
              }
              let secret = this.getQueryVariable(_url.query, "secret");
              let name = this.$t("add_totp_dialog.handle_file_totp_url_name");
              this.$emit("uploadSuccess", { "username": username, "secret": secret, "name": name, "bindShopNum": 1 });
              this.$message.success(this.$t("add_totp_dialog.totp_url_handle_success"));
              this.close();
            } else {
              this.$message.error(
                this.$t("add_totp_dialog.handle_file_totp_url_wrong_error")
              );
            }
          } else {
            this.$message.error(
              this.$t("add_totp_dialog.handle_file_no_qrcode_error")
            );
          }
        } else {
          this.$message.error(
            this.$t("add_totp_dialog.handle_file_error")
          );
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getQueryVariable(search, variable) {
    let query = search.substring(1);
    let vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  }
  base64ToImageData(base64, width, height) {
    return __async(this, null, function* () {
      return new Promise((resolve) => {
        var image = new Image();
        image.addEventListener("load", function(e) {
          var canvasElement = document.createElement("canvas");
          canvasElement.width = width;
          canvasElement.height = height;
          var context = canvasElement.getContext("2d");
          context.drawImage(e.target, 0, 0, width, height);
          resolve(context.getImageData(0, 0, width, height));
        });
        image.src = base64;
        image.hidden = true;
        document.body.appendChild(image);
        setTimeout(() => {
          document.body.removeChild(image);
        }, 1);
      });
    });
  }
  // width,height
  getImageSize(file) {
    return __async(this, null, function* () {
      return new Promise((resolve, reject) => {
        try {
          let filereader = new FileReader();
          filereader.onload = function(e) {
            var _a;
            let data = (_a = e.target) == null ? void 0 : _a.result;
            let image = new Image();
            image.onload = function() {
              let that = this;
              resolve({
                imageData: data,
                width: that.width,
                height: that.height
              });
              that.removeAttribute("src");
              image = null;
            };
            image.onerror = (error) => {
              reject(error);
              image = null;
            };
            image.src = data;
          };
          filereader.readAsDataURL(file);
        } catch (error) {
          reject(error);
        }
      });
    });
  }
  open() {
    this.dialog.visible = true;
  }
  close() {
    this.dialog.visible = false;
  }
};
AddTOTPDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiForm,
      UiSubmit
    }
  })
], AddTOTPDialog);
export {
  AddTOTPDialog as default
};
